import { render, staticRenderFns } from "./CollaborationCircle.vue?vue&type=template&id=2cb4d7bc"
import script from "./CollaborationCircle.vue?vue&type=script&lang=js"
export * from "./CollaborationCircle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports